<template>
    <el-card>
        <div slot="header" class="move">
            <h3>Submissions Via API/Non-API</h3>
        </div>
        <div class="row mt-4 mb-1 ml-2">
            <div class="col-2">
                <div class="row mix-blend-mode-multiple">
                    <div class="col-12 p-0 d-flex align-items-center lender-logo"
                         v-for="(logo, index) in datasets.logos" :key="index"
                         :style="[logo ? {'background-image': 'url(' + logo + ')'} : {}]">
                        <div class="mx-auto lender-text" v-if="!logo">{{ datasets.labels[index] }}</div>
                    </div>
                </div>
            </div>
            <horizontal-bar-chart
                :data="datasets"
                :options="options"
                :style="{'height': ((totalLenders * 40) + 75) + 'px'}"
                class="col-10"
            ></horizontal-bar-chart>
        </div>
    </el-card>
</template>

<script>
import HorizontalBarChart from '../../ambition/dashboard/charts/HorizontalBarChart'

export default {
    name: 'SubmissionsChart',
    components: {
        HorizontalBarChart
    },
    props: [
        'lenderSubmissions',
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            lenderSubmissionsData: [],
            labelLength: 0,
            datasets: [],
            options: {
                responsive: true,
                maintainAspectRatio: false,
                height: 300,
                scales: {
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            precision: 0,
                            fontFamily: "Poppins",
                            padding: 5,
                            boxWidth: 15,
                            fontSize: 12,
                            fontColor: this.graphColorChange(),
                            fontStyle: "normal",
                            callback: function (value, index, values) {
                                return Number(value).toLocaleString("en-AU");
                            }.bind(this)
                        }
                    }],
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            display: false,
                            fontFamily: "Poppins",
                            padding: 5,
                            boxWidth: 15,
                            fontSize: 12,
                            fontColor: this.graphColorChange(),
                            fontStyle: "normal",
                            callback: function (value, index, values) {
                                if (String(value).length > 15)
                                    return String(value).substring(0, 13) + '...'
                                else
                                    return String(value);
                            }
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: 'bottom',
                    labels: {
                        fontFamily: "Poppins",
                        padding: 10,
                        boxWidth: 13,
                        fontSize: 12,
                        fontColor: this.graphColorChange(),
                        fontStyle: "normal"
                    }
                },
                tooltips: {
                    mode: 'label',
                    titleFontFamily: "Poppins",
                    titleFontSize: 13,
                    titleMarginBottom: 15,
                    bodyFontFamily: "Poppins",
                    bodyFontSize: 13,
                    bodySpacing: 15,
                    footerFontFamily: "Poppins",
                    footerFontStyle: "normal",
                    footerFontSize: 13,
                    footerMarginTop: 15,
                    cornerRadius: 0,
                    xPadding: 15,
                    yPadding: 15,
                    backgroundColor: this.graphBGColorChange(),
                    callbacks: {
                        title: function (t, d) {
                            var idx = t[0].index;
                            return d.labels[idx];
                        },
                        label: function (t, d) {
                            var dstLabel = d.datasets[t.datasetIndex].label.replace(/ .*/, '');
                            var xLabel = t.xLabel;
                            return ' ' + dstLabel + ': ' + Number(xLabel).toLocaleString("en-AU");
                        }.bind(this),
                        footer: function (t, d) {
                            return 'TOTAL: ' + (Number(t[0].value) + Number(t[1].value)).toLocaleString("en-AU");
                        }
                    }
                }
            }
        }
    },
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.lenderSubmissionsData = event.lenderSubmissions.lenderSubmissions
            this.labelLength = event.lenderSubmissions.lenderSubmissions.labels.length

            let labels = Object.values(event.lenderSubmissions.lenderSubmissions.labels);
            let logos = Object.values(event.lenderSubmissions.lenderSubmissions.logos);

            this.datasets = {
                datasets: [{
                    label: 'API Submission',
                    backgroundColor: '#4CAF50',
                    data: Object.values(event.lenderSubmissions.lenderSubmissions.values.api_subs)
                }, {
                    label: 'Manual Submission',
                    backgroundColor: '#e12300',
                    data: Object.values(event.lenderSubmissions.lenderSubmissions.values.non_api_subs)
                }],
                labels: labels,
                logos: logos
            }

            this.graphColorChange()
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.lenderSubmissionsData = event.lenderSubmissions.lenderSubmissions
            this.labelLength = event.lenderSubmissions.lenderSubmissions.labels.length

            let labels = Object.values(event.lenderSubmissions.lenderSubmissions.labels);
            let logos = Object.values(event.lenderSubmissions.lenderSubmissions.logos);

            this.datasets = {
                datasets: [{
                    label: 'API Submission',
                    backgroundColor: '#4CAF50',
                    data: Object.values(event.lenderSubmissions.lenderSubmissions.values.api_subs)
                }, {
                    label: 'Manual Submission',
                    backgroundColor: '#e12300',
                    data: Object.values(event.lenderSubmissions.lenderSubmissions.values.non_api_subs)
                }],
                labels: labels,
                logos: logos
            }

            this.graphColorChange()
        })
    },
    computed: {
        totalLenders() {
            return this.labelLength;
        }
    },
    destroyed() {
        Echo.leave(`dashboard.${this.tenantId}.${this.dashboard}`)
    },
    methods: {
        graphBGColorChange() {
            return this.appearance == "white" ? "#fff" : "#000"
        },
        graphColorChange() {
            return this.appearance == 'black' ? "#fff" : "#000"
        }
    }
}
</script>

<style scoped>
.move {
    cursor: move;
}

.lender-logo {
    height: 42px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
}

.lender-logo .lender-text {
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
